<div class="h2 content-title text-center p-3">Közérdekű információk</div>

<div class="content my-3 col-lg-10 mx-auto">
  <div class="h5 content-title text-center py-3 col-lg-10 mx-auto">
    Dunaszentmiklós Község Önkormányzat Adóhatóságának bankszámlaszámai
  </div>
  <div class="px-5 col-lg-8 mx-auto my-4">
    <div class="row">
      <div class="col-lg-6 text-center">Építéményadó</div>
      <div class="col-lg-6 text-center">63200236-11047753</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Telekadó</div>
      <div class="col-lg-6 text-center">63200236-11047863</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Magánszemélyek kommunális adója</div>
      <div class="col-lg-6 text-center">63200236-11047760</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">
        Tartózkodás utáni idegenforgalmi adó
      </div>
      <div class="col-lg-6 text-center">63200236-11047777</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Helyi iparűzési adó</div>
      <div class="col-lg-6 text-center">63200236-11047681</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">
        Termőföld bérbeadásából származó jöv.adó
      </div>
      <div class="col-lg-6 text-center">63200236-11047818</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Gépjármű adó</div>
      <div class="col-lg-6 text-center">63200236-11047708</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Bírság</div>
      <div class="col-lg-6 text-center">63200236-11047791</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Késedelmi pótlék</div>
      <div class="col-lg-6 text-center">63200236-11047801</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Egyéb bevétel</div>
      <div class="col-lg-6 text-center">63200236-11047784</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Idegen bevétel</div>
      <div class="col-lg-6 text-center">63200236-11047715</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Talajterhelési díj</div>
      <div class="col-lg-6 text-center">63200236-11047825</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Illeték</div>
      <div class="col-lg-6 text-center">63200236-11047832</div>
    </div>
  </div>
  <div class="h5 content-title text-center py-3 col-lg-10 mx-auto">
    Orvosi rendelés:
  </div>
  <div class="px-5 col-lg-8 mx-auto my-4">
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col">
            Rendel: Dr. Jordán Gyula<br />
            Elérhetőségek:<br />
            Rendelő (Szomód): 34/491-043<br />
            Dr. Jordán Gyula: 20/3248850<br />
            Horváthné Emi: 30/4218957<br />

            16 óra után és munkaszüneti napokon Tatán központi ügyelet van.<br />
            Helye: Tata, Fürdő u. 19.<br />
            Ügyeleti telefon: 34/381-440<br />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-lg-6 text-center">Hétfő</div>
          <div class="col-lg-6 text-center">8:00-11:00 (Szomód)</div>
        </div>
        <div class="row">
          <div class="col-lg-6 text-center">Kedd</div>
          <div class="col-lg-6 text-center">12:00 - 14:00</div>
        </div>
        <div class="row">
          <div class="col-lg-6 text-center"></div>
          <div class="col-lg-6 text-center">15:00-17:00 (Szomód)</div>
        </div>
        <div class="row">
          <div class="col-lg-6 text-center">Szerda</div>
          <div class="col-lg-6 text-center">8:00-11: (Szomód)</div>
        </div>
        <div class="row">
          <div class="col-lg-6 text-center">Csütörtök</div>
          <div class="col-lg-6 text-center">14:00-17:00 (Szomód)</div>
        </div>
        <div class="row">
          <div class="col-lg-6 text-center">Péntek</div>
          <div class="col-lg-6 text-center">8:00 - 9:00</div>
        </div>
        <div class="row">
          <div class="col-lg-6 text-center"></div>
          <div class="col-lg-6 text-center">11:00-13:00 (Szomód)</div>
        </div>
      </div>
    </div>
  </div>
  <div class="h5 content-title text-center py-3 col-lg-10 mx-auto">
    Házhoz menő szelektív hulladékgyűjtés
  </div>
  <div class="px-5 col-lg-8 mx-auto my-4 text-center">
    <span
      class="dl-span"
      (click)="
        download('Házhoz menő szelektív hulladékgyűjtés', null, 'hulladek')
      "
    >
      <i class="fas mr-3 fa-file-pdf"></i>Tájékoztató letöltése
    </span>
  </div>
  <div class="h5 content-title text-center py-3 col-lg-10 mx-auto">
    Közérdekű adatok igénylése
  </div>
  <div class="px-5 col-lg-8 mx-auto my-4">
    Az információs önrendelkezési jog és az információszabadság biztosítása
    érdekében az információs önrendelkezési jogról és az információszabadságról
    szóló 2011. évi CXII. törvény (a továbbiakban: Infotv.) rendelkezései
    alapján a Tatai Közös Önkormányzati Hivatalban (a továbbiakban: Adatközlő) a
    közérdekű adatok megismerésére irányuló igények teljesítésének rendjét a
    csatolt szabályzat szerint határozom meg.<br />
    A Szabályzat tárgyi hatálya kiterjed a Tatai Közös Önkormányzati Hivatalnál,
    a hivatalt alapító Tata Város Önkormányzatánál, Dunaalmás Község
    Önkormányzatánál, Dunaszentmiklós Község Önkormányzatánál és Neszmély Község
    Önkormányzatánál, valamint a hivatal által kötött megállapodások alapján a
    Tatai Lengyel Nemzetiségi Önkormányzatnál, a Tatai Német Nemzetiségi
    Önkormányzatnál, a Tatai Roma Nemzetiségi Önkormányzatnál, a
    Dunaszentmiklósi Német Nemzetiségi Önkormányzatnál, továbbá a Tatai
    Kistérségi Többcélú Társulásnál keletkezett közérdekű adatok és a
    közérdekből nyilvános adatok teljes körére.
  </div>
</div>
